import logo from "../assets/logo.png";
import "./header.css";
import { Link } from "react-router-dom";

function Header({ user, title }) {
  return (
    <header className="header">
      <img className="header_logo" src={logo} alt="Happer LOGO" />
      <Link to="/landing">
        <h4 className="happer">Happer</h4>
      </Link>
      <p className="left_text">for {user}</p>
      <div className="space_div"></div>
      {title === "Connexion" ? (
        <Link to="/signin">
          <p className="right_text">{title}</p>
        </Link>
      ) : (
        // title === "S'inscrire"
        <Link to="/signup_influencer">
          <p className="right_text">{title}</p>
        </Link>
      )}
    </header>
  );
}

export default Header;
